<!-- filepath: src/components/FeedbackDialog.vue -->
<template>
    <div class="d-flex">
        <v-dialog v-model="dialog" max-width="500">
            <v-card>
                <v-card-title
                    >We value your Feedback! <v-icon color="yellow darken-2">mdi-star-shooting-outline</v-icon>
                    <v-btn right absolute icon @click="dialog = false" color="primary"> <v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-subtitle> Rate your experience</v-card-subtitle>
                <v-card-text>
                    <v-textarea rounded filled v-model="feedback" rows="4" auto-grow placeholder="Write your feedback..." />
                    <!-- <v-alert v-if="success" type="success" dense class="mt-2"> Thank you! We will review your Feedback. </v-alert>
                    <v-alert v-if="error" type="error" dense class="mt-2"> Error while sending your Feedback... Please try again. </v-alert> -->
                </v-card-text>
                <v-card-actions>
                    <v-btn block rounded color="primary" @click="sendFeedback" :disabled="loading"> OK </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <span class="ml-10 mb-5 mr-1" style="margin-top: 6px; font-size: 12px; color: grey; text-align: center; align-items: center"> Feedback:</span>
        <v-btn
            icon
            small
            @click="
                dialog = true
                status = 'positive'
            "
            class="ml-0 mb-5">
            <v-icon small>mdi-thumb-up-outline</v-icon>
        </v-btn>
        <v-btn
            icon
            small
            @click="
                dialog = true
                status = 'negative'
            "
            class="mb-5">
            <v-icon small>mdi-thumb-down-outline</v-icon>
        </v-btn>
    </div>
</template>

<script>
    export default {
        name: "FeedbackDialog",
        props: {
            messages: Array
        },
        data() {
            return {
                status: "",
                dialog: false,
                feedback: "",
                loading: false,
                success: false,
                error: false
            }
        },
        methods: {
            closeDialog() {
                this.dialog = false
                this.feedback = ""
                this.success = false
                this.error = false
            },
            async sendFeedback() {
                this.loading = true
                this.success = false
                this.error = false
                try {
                    await this.$helpers.axiosPost(process.env.VUE_APP_APIURL + "/service/feedback", {
                        feedback: this.status + ": " + this.feedback,
                        messages: this.messages,
                        user: localStorage.getItem("user") || "unknown",
                        company_id: localStorage.getItem("company_id") || "unknown"
                    })
                    this.success = true
                    this.dialog = false
                    this.status = ""
                    this.feedback = ""
                    this.$emit("feedbackSent")
                } catch (e) {
                    console.log(e)
                    this.error = true
                }
                this.loading = false
            }
        }
    }
</script>
